import React from "react";
import { useParams } from "react-router-dom";

const PrivateVideo = () => {
    const { videoId } = useParams();

    if (!videoId) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
                <h1 className="text-2xl font-bold text-gray-800">Video not found</h1>
                <p className="text-gray-600 mt-2">No video ID was provided.</p>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 flex items-center justify-center">
            <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="p-6">
                    <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">
                        Shared Video
                    </h1>
                    <div className="relative aspect-video w-full rounded-lg overflow-hidden bg-black shadow-inner">
                        <iframe
                            className="absolute top-0 left-0 w-full h-full"
                            src={`https://www.youtube.com/embed/${videoId}`}
                            title="Shared Video"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                        ></iframe>
                    </div>
                    <div className="mt-6 text-center text-sm text-gray-500">
                        This video is private and only accessible via this link.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivateVideo;
